import {
    CHANGE_BORING_ID1,
    CHANGE_BORING_ID2,
    CHANGE_YSCALE_EDITER,
    CHANGE_TLIST_EDITER,
    CHANGE_YLIST_EDITER,
    CHANGE_BLIST_EDITER,
    CHANGE_SELROW_EDITER,
    CHANGE_DATA_EDITER,
    REG_EDITER,
    UPDATE_WLTREDITER,
    UPDATE_POMPTREDITER,
    CHANGE_SELMEADATA_EDITER,
    CHANGE_SELMEAROW_EDITER,
    CHANGE_REGMODE_EDITER,
    CHANGE_MAXID_EDITER,
    CHANGE_USERYSCALE_EDITER,
    CHANGE_USERTLIST_EDITER,
    CHANGE_USERYLIST_EDITER,
    CHANGE_USERBLIST_EDITER,
    UPDATE_SCREENTREDITER,
    CHANGE_WLSTLIST_EDITER,
    CHANGE_WLSBLIST_EDITER,
    CHANGE_WLSYLIST_EDITER,
    CHANGE_WLSYSCALE_EDITER,
    CHANGE_DETAILCAT_EDITER

} from './actions';

const initData = {
    boringID1: null,
    boringID2: null,
    YScale: null,
    tList: [],
    YList: [],
    bList: [],
    selRow: null,
    isChange: false,
    isReg: null,
    editerWlMeaData: [],
    editerPompMeaData: [],
    selMeaData: null,
    selMeaRow: null,
    regMode: null,
    maxID: 0,
    userYScale: null,
    userTList: [],
    userYList: [],
    userBList: [],
    editerScreenData: [],
    wlsTList: [],
    wlsBList: [],
    wlsYList: [],
    wlsYScale: null,
    detailCat: null
};

export function editerReducer(state = initData, action) {
    switch (action.type) {
        case CHANGE_BORING_ID1:
            return changeBoringID1Reduce(state, action);
        case CHANGE_BORING_ID2:
            return changeBoringID2Reduce(state, action);
        case CHANGE_YSCALE_EDITER:
            return changeYScaleEReduce(state, action);
        case CHANGE_TLIST_EDITER:
            return changeTListReduce(state, action);
        case CHANGE_YLIST_EDITER:
            return changeYListEReduce(state, action);
        case CHANGE_BLIST_EDITER:
            return changeBListEReduce(state, action);
        case CHANGE_SELROW_EDITER:
            return changeSelRowReduce(state, action);
        case CHANGE_DATA_EDITER:
            return changeDataReduce(state, action);
        case REG_EDITER:
            return regEditerReduce(state, action);
        case UPDATE_WLTREDITER:
            return updateWlTrReduce(state, action);
        case UPDATE_POMPTREDITER:
            return updatePompTrReduce(state, action);
        case CHANGE_SELMEADATA_EDITER:
            return changeSelMeaDataReduce(state, action);
        case CHANGE_SELMEAROW_EDITER:
            return changeSelMeaRowReduce(state, action);
        case CHANGE_REGMODE_EDITER:
            return changeRegModEditereReduce(state, action);
        case CHANGE_MAXID_EDITER:
            return changeMaxIDEditerReduce(state, action);
        case CHANGE_USERYSCALE_EDITER:
            return changeUserYScaleEReduce(state, action);
        case CHANGE_USERTLIST_EDITER:
            return changeUserTListReduce(state, action);
        case CHANGE_USERYLIST_EDITER:
            return changeUserYListEReduce(state, action);
        case CHANGE_USERBLIST_EDITER:
            return changeUserBListEReduce(state, action);
        case UPDATE_SCREENTREDITER:
            return updateScreenTrReduce(state, action);
        case CHANGE_WLSTLIST_EDITER:
            return changewlsTListReduce(state, action);
        case CHANGE_WLSBLIST_EDITER:
            return changeWlsBListEReduce(state, action);
        case CHANGE_WLSYLIST_EDITER:
            return changeWlsYListEReduce(state, action);
        case CHANGE_WLSYSCALE_EDITER:
            return changeWlsYScaleEReduce(state, action);
        case CHANGE_DETAILCAT_EDITER:
            return changeDetailCatReduce(state, action);
        default:
            return state;
    }
}

export function changeBoringID1Reduce(state, action) {
    return {
        ...state,
        boringID1: action.ID
    };
}

export function changeBoringID2Reduce(state, action) {
    return {
        ...state,
        boringID2: action.ID
    };
}

export function changeYScaleEReduce(state, action) {
    return {
        ...state,
        YScale: action.scale
    };
}

export function changeTListReduce(state, action) {
    return {
        ...state,
        tList: action.list
    };
}

export function changeYListEReduce(state, action) {
    return {
        ...state,
        YList: action.list
    };
}

export function changeBListEReduce(state, action) {
    return {
        ...state,
        bList: action.list
    };
}

export function changeSelRowReduce(state, action) {
    return {
        ...state,
        selRow: action.rowID
    };
}

export function changeDataReduce(state, action) {
    return {
        ...state,
        isChange: action.isChange
    };
}

export function regEditerReduce(state, action) {
    return {
        ...state,
        isReg: action.isReg
    };
}

export function updateWlTrReduce(state, action) {
    return {
        ...state,
        editerWlMeaData: action.value
    };
}

export function updatePompTrReduce(state, action) {
    return {
        ...state,
        editerPompMeaData: action.value
    };
}

export function changeSelMeaDataReduce(state, action) {
    return {
        ...state,
        selMeaData: action.value
    };
}

export function changeSelMeaRowReduce(state, action) {
    return {
        ...state,
        selMeaRow: action.value
    };
}

export function changeRegModEditereReduce(state, action) {
    return {
        ...state,
        regMode: action.value
    };
}

export function changeMaxIDEditerReduce(state, action) {
    return {
        ...state,
        maxID: action.value
    };
}

export function changeUserYScaleEReduce(state, action) {
    return {
        ...state,
        userYScale: action.scale
    };
}

export function changeUserTListReduce(state, action) {
    return {
        ...state,
        userTList: action.list
    };
}

export function changeUserYListEReduce(state, action) {
    return {
        ...state,
        userYList: action.list
    };
}

export function changeUserBListEReduce(state, action) {
    return {
        ...state,
        userBList: action.list
    };
}

export function updateScreenTrReduce(state, action) {
    return {
        ...state,
        editerScreenData: action.value
    };
}

export function changewlsTListReduce(state, action) {
    return {
        ...state,
        wlsTList: action.list
    };
}

export function changeWlsBListEReduce(state, action) {
    return {
        ...state,
        wlsBList: action.list
    };
}

export function changeWlsYListEReduce(state, action) {
    return {
        ...state,
        wlsYList: action.list
    };
}

export function changeWlsYScaleEReduce(state, action) {
    return {
        ...state,
        wlsYScale: action.scale
    };
}

export function changeDetailCatReduce(state, action) {
    return {
        ...state,
        detailCat: action.value
    };
}